import { api } from "./apiClient";

export const createBrokerDashboardApi = () => ({
  createLead: (data) => api.post("/brokers/leads", data),

  updateLeadStatus: (leadId, status) =>
    api.patch(`/brokers/leads/${leadId}/status`, { status }),

  notifyQualifiedLead: (leadId) =>
    api.patchQuery(`/brokers/leads/${leadId}/notify-qualified`),

  createCommission: (data) => api.post("/brokers/commissions", data),

  updateCommissionStatus: (id, status) =>
    api.patchQuery(`/brokers/commissions/${id}/status?status=${status}`),

  deleteCommission: (id) => api.delete(`/brokers/commissions/${id}`),

  reserveUnit: (unitId, leadId = null) => {
    const query = leadId ? `?lead_id=${leadId}` : "";
    return api.patchQuery(`/broker-units/unit/${unitId}/reserve${query}`);
  },

  releaseUnit: (unitId) =>
    api.patchQuery(`/broker-units/unit/${unitId}/release`),
});
